import { useQuery } from "@tanstack/react-query";
import Link from "next/link";
import { useRouter } from "next/router";

import OutlineLink from "../../components/form/outlineLink.comp";
import Layout from "../../components/layouts/layout.comp";
import { ListSection } from "../../components/reuseables/list.comp";
import formCore from "../../core/form.core";
import { useTranslation } from "../../core/translation.core";
import LoadingOvalCenterIcon from "../../icons/loadingOvalCenter.icon";
import { FormDef } from "../../types/form";
import AddLink from "../../components/form/addLink.comp";

export default function FormDefListPage() {
  const { t, msg } = useTranslation();
  const { locale } = useRouter();

  const { data: formDefList, isFetched } = useQuery({
    queryKey: ["formDefList", locale],
    queryFn: formCore.listDef,
  });

  return (
    <Layout title={t(msg.form.form)} titleBtn={<AddLink id="create-form-def" href="/form/defCreate" />}>
      <List formDefList={formDefList} isFetched={isFetched} />
    </Layout>
  );
}

const List = ({ formDefList, isFetched }: any) => {
  const { locale } = useRouter();
  const { t, msg } = useTranslation();

  if (!isFetched) return <LoadingOvalCenterIcon />;

  return (
    <ListSection>
      <div id="formDefList-section" className="pt-6 lg:pt-0">
        <div className="hidden lg:grid lg:grid-cols-[1fr_4fr_1fr] gap-6 px-6 py-3 text-sm font-medium">
          <div>{t(msg.category.code)}</div>
          <div>{t(msg.setting.email)}</div>
          <div></div>
        </div>

        {formDefList.map((formDef) => (
          <Row key={formDef.id} formDef={formDef} />
        ))}
      </div>
    </ListSection>
  );
};

const Row = ({ formDef }: { formDef: FormDef }) => {
  const { t, msg } = useTranslation();

  return (
    <div
      attr-code={formDef.code}
      className="grid grid-cols-[100px_auto] lg:grid-cols-[1fr_4fr_1fr] gap-x-6 gap-y-3 px-6 py-6 border-t-[1px] text-sm dark:text-white group/edit"
    >
      <div>{formDef.code}</div>
      <div>
        {formDef.notifyEmails?.map((e) => (
          <p key={e}>{e}</p>
        ))}
      </div>
      <div className="flex gap-5">
        <Link className="form-edit underline" href={`/form/defEdit/${formDef.id}`}>
          {t(msg.form.edit)}
        </Link>
        <Link className="form-view underline" href={`/form/docList/${formDef.id}`}>
          {t(msg.general.view)}
        </Link>
      </div>
    </div>
  );
};
